import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { LngCargoCompressorOptions } from "../../../../../Data/data"; // You need to create and import this

const AddLngCargoCompressorModal = ({ visible, onOk, onCancel, responseData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  useEffect(() => {
    try {
      const defaultParams =
        responseData?.selected_parameters || LngCargoCompressorOptions.map((param) => param.value);
      setSelectedParams(defaultParams);
      if (responseData) {
        form.setFieldsValue({
          compressor_name: responseData?.lng_name || "",
          compressor_maker: responseData?.lng_maker || "",
          compressor_model: responseData?.lng_model || "",
        });
        setCustomParams(
          Array.isArray(responseData?.other_parameters) ? responseData.other_parameters : []
        );
      }
    } catch (error) {
      console.error("Error setting responseData:", error);
    }
  }, [responseData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };
        onOk(data);
        form.resetFields();
        setSelectedParams(LngCargoCompressorOptions.map((param) => param.value));
        setCustomParams([]);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const safeOptions =
    Array.isArray(LngCargoCompressorOptions) && LngCargoCompressorOptions.length > 0
      ? LngCargoCompressorOptions
      : [];

  return (
    <Modal
      title="Add LNG Cargo Compressor Details"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item label="Compressor Name" name="compressor_name">
              <Input placeholder="Compressor Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Compressor Maker" name="compressor_maker">
              <Input placeholder="Compressor Maker" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Compressor Model" name="compressor_model">
              <Input placeholder="Compressor Model" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Select LNG Cargo Compressor Parameters to Log">
              {safeOptions.length > 0 ? (
                <Checkbox.Group
                  value={selectedParams}
                  onChange={(values) => setSelectedParams(values)}
                  style={{ width: "100%" }}
                >
                  <Row gutter={[8, 8]}>
                    {safeOptions.map((param) => (
                      <Col span={12} key={param.value}>
                        <Checkbox value={param.value}>{param.label}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              ) : (
                <div style={{ color: "red" }}>No parameters available</div>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <div style={{ marginTop: 16 }}>
              <b>Add Other Parameters</b>
              {customParams.map((param, index) => (
                <Row gutter={8} key={index} style={{ marginTop: 8 }}>
                  <Col span={9}>
                    <Input
                      placeholder="Parameter"
                      value={param.name}
                      maxLength={50}
                      onChange={(e) => handleCustomChange(index, "name", e.target.value)}
                    />
                  </Col>
                  <Col span={9}>
                    <Input
                      placeholder="Unit"
                      value={param.unit}
                      maxLength={20}
                      onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
                    />
                  </Col>
                  <Col span={6}>
                    <Button danger onClick={() => handleDeleteParam(index)} block>
                      ×
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
                + Add Parameter
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddLngCargoCompressorModal;
